import React from 'react';
import styled from 'styled-components';
import { Flex, Text } from 'pcln-design-system';
import { TrendingUp, TrendingDown } from 'pcln-icons';
const StyledText = /*#__PURE__*/styled(Text).attrs({
  ml: 2,
  my: 'auto'
}).withConfig({
  displayName: "PriceWatchBanner__StyledText",
  componentId: "sc-1fe6ek6-0"
})(["font-weight:700;"]);
/** @public */
function PriceWatch({
  savingsPercentage,
  dealPrice
}) {
  if (savingsPercentage) {
    const wholeNumber = Math.round(Number(savingsPercentage));
    if (wholeNumber > 0) {
      return React.createElement(Flex, {
        width: '100%',
        bg: 'secondary.light',
        color: 'secondary',
        borderRadius: 'md',
        p: 3,
        py: 1,
        mt: 2
      }, React.createElement(TrendingDown, null), React.createElement(StyledText, {
        textStyle: 'subheading6'
      }, `${wholeNumber}% Price Drop`));
    } else {
      return React.createElement(Flex, {
        width: '100%',
        bg: 'error.light',
        color: 'alert.tone',
        borderRadius: 'md',
        p: 3,
        py: 1,
        mt: 2
      }, React.createElement(TrendingUp, null), React.createElement(StyledText, {
        textStyle: 'subheading6'
      }, `${wholeNumber * -1}% Price Increase`));
    }
  } else {
    return React.createElement(Flex, {
      width: '100%',
      bg: 'background.light',
      borderRadius: 'md',
      px: 3,
      py: 1,
      mt: 2,
      justifyContent: 'space-between'
    }, React.createElement(StyledText, {
      textStyle: 'subheading6'
    }, "Last Viewed Price"), React.createElement(Text, {
      pl: 2,
      textStyle: 'subheading5'
    }, `$${dealPrice}`));
  }
}
export default PriceWatch;